import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Steps, Button } from 'antd';

import Layout from '../../Layout';
import PersonalInfoRevamp from '../../components/UsedComp/PersonalInfoRevamp';
import UploadEHR from './UploadEHR';
import ChatBot from '../../components/UsedComp/ChatBot';
import ChatBotResult from './ChatBotResult';

function CreatePatient() {
  const params = useParams();
  const navigate = useNavigate();
  const [currStep, setCurrStep] = useState(params.patientguid ? 1 : 0);

  const steps = [
    {
      title: 'Basic Information',
      description: 'Validate basic information of patient',
    },
    {
      title: 'Upload Information',
      description: 'Upload patient medical information',
    },
    {
      title: 'Genetic Risk Assessment',
      description: 'Check the risk for a genetic disease',
    },
    {
      title: 'Risk status',
      description: 'Summarizing result with Risk status',
    },
  ];

  const stepComponents = [
    <PersonalInfoRevamp setCurrStep={setCurrStep} />,
    <UploadEHR setCurrStep={setCurrStep} />,
    <ChatBot setCurrStep={setCurrStep} />,
    <ChatBotResult setCurrStep={setCurrStep} params={params} />,
  ];

  const handleSkipToGeneticRisk = () => {
    setCurrStep(2); // Skip directly to "Genetic Risk Assessment"
  };

  return (
    <Layout>
      <div className="flex gap-6">
        <Steps
          size="small"
          current={currStep}
          direction="vertical"
          className="h-[70vh] w-1/3"
          items={steps}
        />
        <div className="w-full relative h-[calc(100vh-120px)] flex flex-col">
          {currStep === 2 && (
            <div className="bg-orange-50 p-4 rounded-lg mb-4 flex items-center justify-between flex-shrink-0">
              <span className="text-gray-700">Want to skip the genetic risk assessment?</span>
              <Button
                onClick={() => navigate(`/patients/${params.patientguid}`)}
                type="default"
                className="bg-orange-500 text-white hover:bg-orange-600 border-none transition-all duration-200 px-6 py-2 rounded-full shadow-md ml-4"
              >
                Skip to Patient Profile →
              </Button>
            </div>
          )}
          
          <div className="flex-grow overflow-hidden">
            {stepComponents[currStep]}
          </div>

          {currStep === 1 && (
            <div className="bg-orange-50 p-4 rounded-lg mb-4 flex items-center justify-between flex-shrink-0">
              <span className="text-gray-700">Want to skip the EHR analysis?</span>
              <Button
                onClick={handleSkipToGeneticRisk}
                type="default"
                className="bg-orange-500 text-white hover:bg-orange-600 border-none transition-all duration-200 px-6 py-2 rounded-full shadow-md ml-4"
              >
                Skip to Genetic Risk →
              </Button>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default CreatePatient;
